var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBitcoin = function SvgIconBitcoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#fff",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7931A",
    fillRule: "evenodd",
    d: "M25.627 12.065A8.064 8.064 0 1 1 17.563 4a8.064 8.064 0 0 1 8.064 8.065M19.5 9.068c1.122.386 1.942.962 1.782 2.036-.117.786-.555 1.166-1.136 1.3.797.413 1.069 1.197.817 2.146-.48 1.366-1.62 1.48-3.135 1.195l-.368 1.468-.888-.22.363-1.449q-.345-.085-.708-.183l-.365 1.455-.887-.22.367-1.472-1.79-.45.442-1.013s.655.173.646.16c.252.063.364-.1.407-.21l.998-3.983c.01-.188-.054-.425-.414-.515.013-.01-.646-.16-.646-.16l.237-.945 1.792.442.364-1.454.888.22-.357 1.426q.36.081.712.167l.355-1.416.888.22zm-2.126 2.426c.606.16 1.922.51 2.152-.406.234-.936-1.045-1.22-1.672-1.358l-.184-.042-.443 1.768zm-.685 2.846c.725.191 2.31.609 2.562-.4.258-1.031-1.279-1.375-2.029-1.542l-.218-.05-.488 1.948z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBitcoin;